<template>
  <base-dialog
    :is-open="isOpen"
    @close="handleClose"
  >
    <template #dialog-title>Summenliste erzeugen</template>
    <template #dialog-text>
      <v-row>
        <v-col>
          <p>Die Summenliste zeigt alle abgerechneten Zahlungen gruppiert nach Sammlungen in einem Zeitraum. Die Summenliste für den Vormonat ist erst vollständig, wenn die zugehörige Abgleichliste verfügbar ist.</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <text-field-date-picker
            v-model="startDate"
            label="Von"
          ></text-field-date-picker>
          <text-field-date-picker
            v-model="endDate"
            label="Bis"
          ></text-field-date-picker>
        </v-col>
        <v-col class="d-flex flex-column">
          <v-btn
            color="primary"
            outlined
            class="mb-2"
            @click="setLastMonth"
          >
            Letzter Monat
          </v-btn>
          <v-btn
            color="primary"
            outlined
            class="mb-2"
            @click="setLastQuarter"
          >
            Letztes Quartal
          </v-btn>
          <v-btn
            color="primary"
            outlined
            @click="setCurrentYear"
          >
            Laufendes Jahr
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-switch
            v-model="includeChildren"
            label="Unterorganisationen einschließen"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row v-if="!isValid">
        <v-col>
          <v-alert
            color="primary"
            outlined
            dense
            class="text-body-2"
          >
            {{ validationMessage }}
          </v-alert>
        </v-col>
      </v-row>
    </template>
    <template #dialog-actions>
      <v-btn
        color="primary"
        text
        @click="handleClose"
      >
        Schliessen
      </v-btn>
      <v-btn
        color="primary"
        :disabled="!isValid"
        @click="generateReport"
      >
        Erzeugen
      </v-btn>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UI/BaseDialog.vue"
import TextFieldDatePicker from "@/components/UI/TextFieldDatePicker.vue"
import { mapGetters } from "vuex"
import moment from "moment"
import { downloadBlob } from "@/lib/file-tools"

export default {
  name: 'EvalInvoicingSumListDialog',
  components: { BaseDialog, TextFieldDatePicker },
  emits: ['close'],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      startDate: null,
      endDate: null,
      includeChildren: false
    }
  },
  computed: {
    ...mapGetters('organization', ['currentOrganization']),
    isValid () {
      if (!this.startDate || !this.endDate) return false
      const start = moment(this.startDate, 'DD.MM.YYYY')
      const end = moment(this.endDate, 'DD.MM.YYYY')
      return start.isSameOrBefore(end)
    },
    validationMessage () {
      if (!this.startDate || !this.endDate) {
        return 'Bitte Start- und Enddatum angeben.'
      }
      return 'Das Startdatum darf nicht nach dem Enddatum liegen.'
    }
  },
  methods: {
    setLastMonth () {
      const lastMonth = moment().subtract(1, 'month')
      this.startDate = lastMonth.startOf('month').format('DD.MM.YYYY')
      this.endDate = moment().subtract(1, 'month').endOf('month').format('DD.MM.YYYY')
    },
    setLastQuarter () {
      const lastQuarter = moment().subtract(1, 'quarter')
      this.startDate = lastQuarter.startOf('quarter').format('DD.MM.YYYY')
      this.endDate = moment().subtract(1, 'quarter').endOf('quarter').format('DD.MM.YYYY')
    },
    setCurrentYear () {
      this.startDate = moment().startOf('year').format('DD.MM.YYYY')
      this.endDate = moment().format('DD.MM.YYYY')
    },
    handleClose () {
      this.$emit('close')
    },
    async generateReport () {
      const since = moment(this.startDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
      const before = moment(this.endDate, 'DD.MM.YYYY').add(1, 'day').format('YYYY-MM-DD')
      const params = new URLSearchParams({
        tz: 'Europe/Berlin',
        recursive: this.includeChildren ? '1' : '0',
        since,
        before
      })
      const url = `organization/${this.currentOrganization.id}/sum_report/?${params}`
      const response = await this.$store.getters.restApi.get(url, {
        responseType: 'blob'
      })
      const endDateIso = moment(this.endDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
      const orgName = this.currentOrganization.name.replace(/\s+/g, '_')
      const filename = `${since}_${endDateIso}_${orgName}.xlsx`
      downloadBlob(response.data, filename, response.headers['content-type'])
    }
  }
}
</script>
